import Football from '../../../assets/icons/football.svg?react';
import Globe from '../../../assets/icons/globe.svg?react';
import Avatar from '../../../assets/icons/avatar.svg?react';
import Logout from '../../../assets/icons/logout.svg?react';
import Test from '../../../assets/icons/test.svg?react';
import Mower from '../../../assets/icons/mower.svg?react';
import Settings from '../../../assets/icons/settings.svg?react';

export const Icons = {
  Football,
  Globe,
  Avatar,
  Logout,
  Test,
  Mower,
  Settings,
};
